import React, { Component, Fragment } from "react";
import ReactDatatable from 'react-data-table-component';
//import compoentns
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { momentFormat, dateTimeFormat } from "../../lib/dateTimeHelper";
//imprt actions
import { TicketList } from '../../actions/supportAction';
import config from "../../config/index";


//import downloads
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
import { CSVLink } from "react-csv";
// import Link from "react-csv/components/Link";
import { Link, withRouter } from 'react-router-dom';
import { connectWallet } from "../../lib/useWallet";
import contractProvider from "../../lib/contractProvider";
import CompleteDepositModal from "../partials/CompleteDepositModal";
import { toastAlert } from "../../lib/toastAlert";
import Web3 from "web3";
import CompletedTradeModal from "../partials/CompleteTradeModal";
import { ApproveDeposit } from "../../actions/P2PCreateaction";

class Support extends Component {

    constructor(props) {

        super(props);

        this.state = {
            records: [],
            page: 1,
            limit: 10,
            count: 0,
            loader: false,
            showDepositModal: false,
            depositData: {},
        };
console.log('this.stattte',this.state)
        this.columns = [
            {
                key: "tickerId",
                text: "Ticket ID",
                className: "Id",
                align: "left",
                sortable: false,
                name: "Ticket ID",
                cell: record => <>{record?.tickerId}</>,
            },
            {
                key: "ursUiqueId",
                text: "User Id",
                className: "userName",
                align: "left",
                sortable: false,
                name: "User Id",
                cell: record => <>{record?.ursUiqueId}</>,
            },
            {
                key: "email",
                text: "Email",
                className: "userName",
                align: "left",
                sortable: false,
                name: "Email",
                cell: record => <>{record?.email}</>,
            },
            {
                key: "categoryName",
                text: "Category Name",
                className: "categoryName",
                align: "left",
                sortable: false,
                name: "Category Name",
                cell: record => <>{record?.categoryName}</>,
            },
            {
                key: "status",
                text: "Status",
                className: "status",
                align: "left",
                sortable: false,
                name: "Status",
                cell: record => <>{record?.status}</>,
            },
            {
                key: "createdAt",
                text: "Date",
                className: "createdAt",
                align: "left",
                sortable: false,
                filter: 'between',
                name: "Date",
                cell: (record) => {
                    return momentFormat(record.createdAt, 'YYYY-MM-DD HH:mm')
                },
            },
            {
                key: "action",
                text: "Action",
                className: "action",
                width: 100,
                align: "left",
                sortable: false,
                name: "Action",
                cell: record => {
                    console.log('recordrecord', record)
                    if (record.status == "closed") {
                        return "-"
                    }
                    if (record.status == "open") {
                        return (
                            <Fragment>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => this.editRecord(record.tickerId)}
                                    style={{ marginRight: '5px' }}>
                                    <i className="fa fa-reply"></i>
                                </button>

                                {record?.roomid && <a target="_blank" href={`${config?.FRONT_URL}${record?.roomid}`}
                                    className="btn btn-primary btn-sm"
                                    // onClick={() => this.viewchat(record)}
                                    style={{ marginRight: '5px' }}>
                                    <i className="fa fa-reply"></i>
                                </a>}

                                {/* <Link to={window.location.origin+`/trade/"${record?.roomid}`} >View</Link> */}
                                {record?.roomid && record?.tradeHistory && record?.tradeHistory?.depositType == "otp" &&
                                    record?.tradeHistory?.status == "paid" && record?.tradeHistory?.completeToWalletAddress &&
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => this.openDepositModal({
                                            amount: record?.tradeHistory?.receive,
                                            contractAddress: record?.p2pOrderDetails?.tradeContractAddress,
                                            depositUniqueId: record?.p2pOrderDetails?.depositId,
                                            completeFullAmount: false,
                                            withdrawAddress: record?.tradeHistory?.completeToWalletAddress,
                                            chainId: record?.currencyDetails?.chainId,
                                            p2pOrderId: record?.p2pOrderDetails?._id,
                                            tradeHistoryId: record?.tradeHistory?._id
                                        })}
                                        style={{ marginRight: "5px" }}
                                    >
                                        <i className="fa fa-exchange" />
                                    </button>
                                }
                            </Fragment>
                        );
                    }
                }
            },
            // {
            //     key: "Action",
            //     text: "Complete Pay",
            //     className: "Fees",
            //     align: "left",
            //     width: 200,
            //     name: "Action",
            //     cell: record => <>
            //         {/* record?.orderdata?.preferedcurrency */}
            //         {
            //             console.log('orderdataorderdata', record?.status, record?.paymentGatewayStatus, record?.orderdata)
            //         }
            //         {
            //             record?.depositType == 'otp' && record?.paymentGatewayStatus == "paid" && record?.status != 'confirm'
            //                 ?
            //                 <>
            //                     <button
            //                         className="btn btn-primary btn-sm"
            //                         onClick={()=>this.completePopOpen(record)}
            //                     >
            //                         Complete
            //                     </button>
            //                 </>
            //                 :
            //                 <>{record?.status}</>
            //         }
            //     </>
            // },
        ];

        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            filename: "Cms",
            no_data_text: 'No Enquires found!',
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Filter in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "<<",
                    previous: "<",
                    next: ">",
                    last: ">>"
                }
            },
            show_length_menu: false,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };

        this.getData = this.getData.bind(this);
        this.handlePagination = this.handlePagination.bind(this)
        this.exportPDF = this.exportPDF.bind(this)
        this.DownoladeCSV = this.DownoladeCSV.bind(this)
        this.DownoladeXLS = this.DownoladeXLS.bind(this)

    }


    async componentDidMount() {
        const { page, limit} = this.state;
      
        const reqData = {
          page,
          limit,
          export: 'false'
        };
        this.getData(reqData);

        // try {
        //   const type = window.ethereum ? "Metamask" : "Walletconnect";
        //   const accountDetails = await connectWallet(type);
        //   console.log("accountDetails", accountDetails.accountAddress);
      
        //   if (!accountDetails?.accountAddress) {
        //     toastAlert("error", "Wallet connection failed");
        //     return;
        //   }
      
        //   this.setState({
        //     walletAddress: accountDetails.accountAddress,
        //     web3: new Web3(window.ethereum),
        //   });
        // } catch (error) {
        //   console.error("Wallet connection error:", error);
        //   toastAlert("error", "Failed to connect wallet");
        // }
    }
      

    async viewchat(record) {
        // window.location.href = window.location.origin ==
        this.props.history.push(`/trade/${record.roomid}`);
    }

    async getData(reqData) {

        try {
            this.setState({ 'loader': true })

            const { status, loading, result } = await TicketList(reqData);
            console.log('resultresult', result)
            this.setState({ 'loader': loading })
            if (status == 'success') {
                this.setState({ "count": result.count, 'records': result.data })
            }
        } catch (err) { }
    }

    async exportPDF() {
        const { records } = this.state;
        const { page, limit } = this.state;
        let reqData = {
            page,
            limit,
            export: 'pdf'
        }
        const { status, loading, result } = await TicketList(reqData);
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(13);

        const title = "Support";
        const headers = [
            [
                "Ticket ID",
                "Category Name",
                "Status",
                "Date",

            ],
        ];

        const data =
            result && result.pdfData.length > 0 &&
            result.pdfData.map((elt) => [

                elt.tickerId,
                elt.categoryName,
                elt.status,
                elt.createdAt
            ]);

        let content = {
            startY: 50,
            head: headers,
            body: data,
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("Support.pdf");
    }

    handlePagination(index) {
        let reqData = {
            page: index.page_number,
            limit: index.page_size,
            search: index.filter_value
        }
        this.getData(reqData);
        this.setState({ page: index.page_number, limit: index.page_size, search: index.filter_value })
    }

    editRecord(id) {

        this.props.history.push('/support_reply/' + id)

    }

    async DownoladeCSV() {
        const { records } = this.state;
        const { page, limit } = this.state;
        let reqData = {
            page,
            limit,
            export: 'csv'
        }
        const { status, loading, result } = await TicketList(reqData);
    }

    async DownoladeXLS() {
        const { records } = this.state;
        const { page, limit } = this.state;
        let reqData = {
            page,
            limit,
            export: 'xls'
        }
        const { status, loading, result } = await TicketList(reqData);
    }

    handleExchange = async () => {
        const { depositData, walletAddress, web3 } = this.state;
    
        try {
          if (!walletAddress || !web3) {
            toastAlert("error", "Wallet not connected");
            return;
          }
    
          const result = await contractProvider.completeDeposit({
            accountAddress: walletAddress,
            amount: depositData.amount,
            web3,
            contractAddress: depositData.contractAddress,
            depositUniqueId: depositData.depositUniqueId,
            completeFullAmount: depositData.completeFullAmount,
            withdrawAddress: depositData.withdrawAddress,
          });
    
          if (result?.error) {
            toastAlert("error", result.errorMessage);
          } else {
            toastAlert("success", "Deposit completed successfully!");
          }
    
          this.closeDepositModal();
        } catch (error) {
          console.error(error);
          toastAlert("error", error.message || "Something went wrong");
        }
      };

    openDepositModal = (data) => {
        console.log("openDepositModaldata", data)
        this.setState({ showDepositModal: true, depositData: data });
    };

    closeDepositModal = () => {
        this.setState({ showDepositModal: false, depositData: {} });
    };

    handleApproveDeposit = async (reqData) => {
        try {
          this.setState({ loader: true });
      
          const result = await ApproveDeposit(reqData);
          console.log("handleApproveDeposit", result);
      
          if (result?.data?.type === "success") {
            toastAlert("success", result?.data?.message);
            this.closeDepositModal();
            window.location.reload();
          } else {
            toastAlert("error", result?.data?.message);
          }
      
          this.setState({ loader: false });
        } catch (err) {
          console.log("handleApproveDepositerr", err);
        }
      };
      
    


    render() {
        const { count, records } = this.state;
        return (
            <div>
                <Navbar />
                <div className="d-flex" id="wrapper">
                    <Sidebar />
                    {this.state.showDepositModal &&
                    <>
                        {/* <CompleteDepositModal
                            isShow={this.state.showDepositModal}
                            onHide={this.closeDepositModal}
                            onConfirm={this.handleExchange}
                        /> */}
                        <CompletedTradeModal
                            isShow={this.state.showDepositModal}
                            record={this.state.depositData}
                            onHide={()=>this.closeDepositModal()}
                            handleApproveDeposit={this.handleApproveDeposit}
                        />
                    </>
                    }
                    <div id="page-content-wrapper">
                        <div className="container-fluid user_asset_modal_table">
                            <h3 className="mt-2 text-secondary mb-4">Support Ticket List</h3>

                            {records && records.length > 0 ? (
                                <button onClick={this.exportPDF} className='btn btn-info mr-2 mb-2' style={{ width: '118px', height: '35px', fontSize: '13px' }}>Download(PDF)</button>
                            ) : (
                                ""
                            )}

                            {records && records.length > 0 ? (



                                <button className='btn btn-info mr-2 mb-2' onClick={this.DownoladeCSV} style={{ width: '118px', height: '35px', fontSize: '13px' }}>Download(CSV)</button>

                            ) : (
                                ""
                            )}

                            {records && records.length > 0 ? (

                                <button className='btn btn-info mb-2' onClick={this.DownoladeXLS} style={{ width: '118px', height: '35px', fontSize: '13px' }}>Download(XLS)</button>

                            ) : (
                                ""
                            )}
                            <ReactDatatable className="table table-bordered table-striped  support_table"
                                config={this.config}
                                data={this.state.records}
                                columns={this.columns}
                                dynamic={true}
                                total_record={count}
                                onChange={this.handlePagination}
                                pagination
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}



export default (withRouter(Support));
